<!-- ------------------------Компонент розділення чеку ----------------------------------- -->
<template>
  <smallModal @escape="$emit('close')">
    <div class="head-div">
      <div class="h5-div">
        <h5 class="larger"><b>{{ lang['inviteComp'] }}</b></h5>
      </div>
      <div class="icon-div" @click="$emit('close')"><b-icon-x scale="2"></b-icon-x></div>
    </div>
    <h6 class="invite-text">{{ lang['AcceptInvitation'] }} "{{ companyData.company_name }}"?</h6>
    <div class="buttons">
      <button class="btn btn-secondary" @click="deleteInvite">{{ lang['Reject'] }}</button>
      <button class="btn btn-success" @click="save">{{ lang['ToAccept'] }}</button>
    </div>
  </smallModal>
</template>

<script>
import { regAPi } from '@/API.js';
import { store } from '@/store'; // Глобальне сховище даних
import smallModal from '../modals/smallModal'; // Компонент маленького модального вікна

const apiList = new regAPi();
export default {
  props: ['companyData'],
  components: {
    smallModal
  },
  data() {
    return {
      login: ''
    }
  },
  methods: {
    /**
     * Сохраняем инвапйт от компании
     * компания сразу переносится в список компаний
     */
    save() {
      try {
        apiList.acceptInv({ company_id: this.companyData.company_id, token: store.token }).then(resp => {
          if (resp.data.status == 'done') {
            window.say.message(this.lang['Saved']);
            this.$emit('close');
          } else {
            window.say.messageError(this.lang['Error']);
          }
        })
      } catch (err) {
        window.say.messageError(this.lang['Error']);
      }
    },
    // Видаляємо запрошення від компанії
    deleteInvite() {
      try {
        apiList.canselInv({ company_id: this.companyData.company_id, token: store.token }).then(resp => {
          if (resp.data.status == 'done') {
            window.say.message(this.lang['Saved']);
            this.$emit('close');
          } else {
            window.say.messageError(this.lang['Error']);
          }
        })
      } catch (err) {
        window.say.messageError(this.lang['Error']);
      }
    }
  },
  computed: {
    // Мова додатку
    lang() {
      return window.lang;
    }
  }
}
</script>

<style scoped>
.buttons {
  display: flex;
  justify-content: space-between;
}

  .btn-secondary,
  .btn-success {
    width: 49%;
  }

  .btn-success {
    background: #00c279;
    border-color: #00c279;
    text-transform: uppercase;
    font-size: 10pt;
  }
  
  .btn-success:hover {
    background: #00B26F;
    border-color: #00B26F;
  }

  .btn-secondary{
    color: gray;
    background-color: white;
    border: none;
    text-transform: uppercase;
    font-size: 10pt;
  }

  .btn-secondary:hover {
    text-decoration: underline;
    color: gray;
    background-color: white;
  }

  .btn-secondary:active {
    text-decoration: underline;
    color: gray;
    background-color: white;
  }

  .h5-div {
    padding-top: 7px;
    padding-right: 30px;
  }

.btn-success:not(:disabled):not(.disabled):active {
  background-color: #00B26F;
}

.btn-success:hover {
  background-color: #00B26F;
}

.btn-danger {
  background-color: #ff3548;
  border: none;
  font-size: 10pt;
}

.btn-danger:not(:disabled):not(.disabled):active {
  background-color: #00B26F;
}

.btn-danger:hover {
  background-color: #de3040;
}

.h5-div {
  padding-top: 7px;
  padding-right: 30px;
}

.icon-div {
  margin-left: auto;
  cursor: pointer;
}

.head-div {
  display: flex;
  margin-bottom: 0.5rem;
}

.larger {
  font-size: larger;
}

.invite-text {
  max-width: 300px;
  color: #8A8E91;
  margin-bottom: 1rem;
}
</style>